<script>
import Dropdown from "primevue/dropdown";

export default {
    name: "XDropDown",
    computed: {

        containerClass() {
            return [
                'p-dropdown p-component p-inputwrapper',
                {
                    'p-disabled': this.disabled,
                    'p-dropdown-clearable': this.showClear && !this.disabled,
                    'p-focus': this.focused,
                    'p-inputwrapper-filled': this.modelValue || (this.modelValue === false) || (this.modelValue === 0) || (this.modelValue === '0'),
                    'p-inputwrapper-focus': this.focused || this.overlayVisible
                }
            ];
        },

    },
    extends: Dropdown
}
</script>

<style scoped>

</style>